import PropTypes from "prop-types";
import React, { useState, useEffect, Fragment, useRef } from "react";
import { v4 as uuidv4 } from "uuid";
// import Tooltip from "../Tooltip";
import { RenderDisplayTooltip } from "./ColumnTooltip";
import addSpanToText from "./AddSpanToText";

function MoreIcon({ tooltipText }) {
  const elementRef = useRef();

  return (
    <div
      className="c-table-records-more-icon-tooltip"
      data-tip={tooltipText}
      data-for="c-table-records-more-tooltip"
    >
      <div
        ref={elementRef}
        className="c-table-records-more-icon-tooltip__button"
      >
        <svg
          className="c-table-records-more__right"
          width="5"
          height="10"
          viewBox="0 0 8 16"
          role="img"
          aria-hidden="true"
        >
          <path
            d="M5 8l-5 8h3l5-8-5-8H0z"
            fill="#687992"
            fillRule="evenodd"
            role="presentation"
          ></path>
        </svg>
        <svg
          className="c-table-records-more__left"
          width="5"
          height="10"
          viewBox="0 0 8 16"
          role="img"
          aria-hidden="true"
        >
          <path
            d="M5 8l-5 8h3l5-8-5-8H0z"
            fill="#687992"
            fillRule="evenodd"
            role="presentation"
          ></path>
        </svg>
      </div>
    </div>
  );
}

function Row(props) {
  const {
    indexofRecord,
    id,
    header,
    headerAlign,
    showBlock,
    nestedHeaderAlign,
    floatingPoints,
    nestedFloatingPoints,
    indexOfGroupHeader,
    indexOfNestedGroupHeader,
    columnColor,
    records,
    enableSelection,
    recordsView,
    selected: _selected,
    onRecordClick,
    onSelectionChanged,
    viewable,
    hasFooter,
    rowSpan,
    removeBottomBorders,
    moreIconTooltip,
    numberOfLines,
    verticalAlign,
    monospaceNumbers,
    maximumRow,
    textColors,
    secondPagination,
    finalRow,
    disableBorderRadius,
  } = props;

  const [selected, setSelected] = useState(_selected || false);
  const Isviewable = recordsView.find((item) => item == indexofRecord);

  if (!records) throw new Error("records cannot be empty");

  let className = `c-table-records__record${
    props.selected ? " c-table-records__record--selected" : ""
  }`;

  let viewableLabel = "";
  if (viewable) {
    className += " c-table-records__record--viewable";
    viewableLabel += "c-table-records__record__label--viewable";
  }

  if (hasFooter) {
    className += " c-table-records__footer";
  }

  if (removeBottomBorders) {
    className += " c-table-records--disable-border";
  }

  function handleSelectionChanged(e) {
    if (onSelectionChanged) onSelectionChanged(e);
    setSelected(e);
  }

  function handleRecordClick() {
    if (enableSelection && selected) {
      setSelected(false);
      return;
    }
    if (viewable === true && onRecordClick && Isviewable == undefined)
      onRecordClick();
  }

  function sortDataSourceKeys(keys) {
    let sortingArr = [];

    for (let key of keys) {
      if (indexOfNestedGroupHeader[key]) {
        sortingArr[indexOfNestedGroupHeader[key]] = key;
      } else {
        sortingArr.push(key);
      }
    }

    return sortingArr;
  }

  const renderMaxWidth = (headerValue, value) => {
    if (headerValue === null)
      return <label className={viewableLabel}>{value}</label>;

    return (
      <RenderDisplayTooltip
        width={headerValue}
        value={value}
        viewableLabel={viewableLabel}
        numberOfLines={numberOfLines}
      />
    );
  };

  useEffect(() => {
    setSelected(props.selectedAllRecords);
  }, [props.selectedAllRecords]);

  let borderRadiusRecords = {};
  let removeBottomBordersStyle = removeBottomBorders
    ? {
        borderBottomRightRadius: "0px",
        borderBottomLeftRadius: "0px",
        borderBottom: "none",
      }
    : {};
  let selectedBoxStyle = enableSelection ? {} : { display: "none" };
  let selectedBgColor = columnColor
    ? columnColor[0] || "transparent"
    : "#F3F3F3";

  if (secondPagination) {
    removeBottomBordersStyle = {
      borderBottomRightRadius: "0px",
      borderBottomLeftRadius: "0px",
    };
  }

  if (enableSelection && finalRow) {
    removeBottomBordersStyle = {
      borderBottomLeftRadius: "0px",
      borderBottomRightRadius: "10px",
    };

    selectedBoxStyle = {
      borderBottomLeftRadius: "10px",
      borderBottomRightRadius: "0px",
    };
  }

  if (secondPagination || disableBorderRadius) {
    borderRadiusRecords = {
      borderBottomRightRadius: "0px",
      borderBottomLeftRadius: "0px",
    };
  }

  return (
    <>
      <tr
        key={id || uuidv4()}
        className={className}
        style={{
          backgroundColor: `${rowSpan !== 1 ? "transparent" : ""}`,
          boxShadow: `${maximumRow !== 1 ? "none" : "0px 1px 0px #eaf0fa"}`,
          ...borderRadiusRecords,
        }}
      >
        <td
          className="c-table-records__checkbox"
          onClick={() => handleSelectionChanged(!selected)}
          style={{
            backgroundColor: `${selectedBgColor}`,
            ...removeBottomBordersStyle,
            ...selectedBoxStyle,
          }}
        >
          {enableSelection && !hasFooter && (
            <input
              type="checkbox"
              checked={selected}
              onChange={() => {
                // This is intentional
              }}
            />
          )}
        </td>
        {records.map((record, i) => {
          if (Array.isArray(record)) {
            let style = {
              backgroundColor: columnColor[i],
              ...removeBottomBordersStyle,
            };
            let firstItem = record[0];
            let keys = Object.keys(firstItem);
            let render = [];

            let rearrange = [];
            let countFirstItemPush = 0;

            for (const key of keys) {
              if (Array.isArray(firstItem[key])) {
                let localArr = firstItem[key].map((r, index) => {
                  let getKeys = Object.keys(r);

                  let localStyle = {
                    backgroundColor: columnColor[i + (index + 1)],
                    ...removeBottomBordersStyle,
                  };

                  for (const localKey of getKeys) {
                    if (Array.isArray(r[localKey])) {
                      rearrange = [];

                      for (const item of r[localKey]) {
                        rearrange[indexOfGroupHeader.indexOf(item.name)] = item;
                      }

                      return rearrange.map((item, t) => {
                        let keys = Object.keys(item);
                        // Sort by columns key in first row
                        let sortingArr = sortDataSourceKeys(keys);

                        return sortingArr.map((k, j) => {
                          if (k !== keys[0]) {
                            let text = item[k];

                            // * check key in nested floating points and assign floating point
                            if (nestedFloatingPoints[k]) {
                              text = item[k].toLocaleString("en-US", {
                                minimumFractionDigits: nestedFloatingPoints[k],
                              });
                            }

                            let className = "c-table-records__nested-record";

                            if (showBlock) {
                              className =
                                "c-table-records__nested-record-block";
                            }

                            return (
                              <td
                                key={`first-group-row-${index}-${j}`}
                                className={className}
                                style={{
                                  ...localStyle,
                                  textAlign: nestedHeaderAlign[t][j - 1],
                                  borderBottom: `${
                                    showBlock ? "1px solid #eaf0fa" : 0
                                  }`,
                                  boxShadow: `${
                                    maximumRow === 1
                                      ? "none"
                                      : "0px 1px 0px #eaf0fa"
                                  }`,
                                }}
                              >
                                <label className={viewableLabel}>
                                  {monospaceNumbers
                                    ? addSpanToText(text)
                                    : text}
                                </label>
                              </td>
                            );
                          }
                        });
                      });
                    } else {
                      if (countFirstItemPush < 1) {
                        firstItem[key].map((item) => {
                          rearrange[
                            indexOfGroupHeader.indexOf(item[getKeys[0]])
                          ] = item;
                        });

                        countFirstItemPush++;

                        return rearrange.map((item, t) => {
                          let keys = Object.keys(item);
                          // Sort by columns key in first group rows
                          let sortingArr = sortDataSourceKeys(keys);

                          return sortingArr.map((k, j) => {
                            if (k !== keys[0]) {
                              let text = item[k];

                              // * check key in nested floating points and assign floating point
                              if (nestedFloatingPoints[k]) {
                                text = item[k].toLocaleString("en-US", {
                                  minimumFractionDigits:
                                    nestedFloatingPoints[k],
                                });
                              }

                              let className = "c-table-records__nested-record";

                              if (showBlock) {
                                className =
                                  "c-table-records__nested-record-block";
                              }

                              return (
                                <td
                                  key={`first-group-row-${index}-${j}`}
                                  className={className}
                                  style={{
                                    ...localStyle,
                                    textAlign: nestedHeaderAlign[t][j - 1],
                                    borderBottom: `${
                                      showBlock ? "1px solid #eaf0fa" : 0
                                    }`,
                                    boxShadow: `${
                                      maximumRow === 1
                                        ? "none"
                                        : "0px 1px 0px #eaf0fa"
                                    }`,
                                  }}
                                >
                                  {monospaceNumbers
                                    ? addSpanToText(text)
                                    : text}
                                </td>
                              );
                            }
                          });
                        });
                      }
                    }
                  }
                });

                render.push(...localArr);
              } else {
                let borderRight = 0;

                if (showBlock && keys.indexOf(key) !== keys.length - 1) {
                  borderRight = "1px solid #eaf0fa";
                }

                render.push(
                  <td
                    key={`first-group-row-${i}`}
                    style={{
                      ...style,
                      textAlign: headerAlign[i],
                      borderRight: borderRight,
                      borderBottom: `${showBlock ? "1px solid #eaf0fa" : 0}`,
                      boxShadow: `${
                        maximumRow === 1 ? "none" : "0px 1px 0px #eaf0fa"
                      }`,
                    }}
                    align={headerAlign[i]}
                  >
                    <label className={viewableLabel}>
                      {monospaceNumbers
                        ? addSpanToText(firstItem[key])
                        : firstItem[key]}
                    </label>
                  </td>
                );
              }
            }
            return render;
          }

          let newRecord = record;

          if (typeof record === "number" && floatingPoints[i]) {
            newRecord = newRecord.toLocaleString("en-US", {
              minimumFractionDigits: floatingPoints[i],
            });
          }

          let displayRenderMaxWidth = undefined;

          if (!numberOfLines) {
            displayRenderMaxWidth = renderMaxWidth(
              header[i],
              monospaceNumbers ? addSpanToText(newRecord) : newRecord
            );
          }

          if (numberOfLines) {
            displayRenderMaxWidth = (
              <RenderDisplayTooltip
                width={header[i]}
                value={monospaceNumbers ? addSpanToText(newRecord) : newRecord}
                viewableLabel={viewableLabel}
                numberOfLines={numberOfLines}
              />
            );
          }

          const dataToDisplay = React.isValidElement(newRecord)
            ? newRecord
            : displayRenderMaxWidth;

          let backgroundColor = "";

          if (columnColor) {
            backgroundColor = columnColor[i];
          }

          let borderRight = 0;

          if (showBlock && i < records.length - 1) {
            borderRight = "1px solid #eaf0fa";
          }

          let styles = {};

          if (textColors && textColors[i]) {
            styles = { color: textColors[i] };
          }

          if (enableSelection && finalRow) {
            if (i === records.length - 1) {
              removeBottomBordersStyle = { borderBottomRightRadius: "10px" };
            }

            if (i < records.length - 1) {
              removeBottomBordersStyle = { borderBottomLeftRadius: "0px" };
            }
          }

          if (disableBorderRadius) {
            removeBottomBordersStyle = {
              borderBottomRightRadius: "0px",
              borderBottomLeftRadius: "0px",
            };
          }

          let styleColumn = {
            maxWidth: header[i],
            width: header[i],
            textAlign: headerAlign[i],
            backgroundColor: backgroundColor,
            borderRight: borderRight,
            boxShadow: `${maximumRow === 1 ? "none" : "0px 1px 0px #eaf0fa"}`,
            borderBottom: `${showBlock ? "1px solid #eaf0fa" : 0}`,
            ...styles,
            ...removeBottomBordersStyle,
          };

          if (finalRow && i === 0 && !enableSelection && !disableBorderRadius) {
            styleColumn = {
              ...styleColumn,
              borderBottomLeftRadius: secondPagination ? "0px" : "10px",
            };
          }

          if (verticalAlign) {
            styleColumn.verticalAlign = verticalAlign;
          }

          return (
            <td
              key={`data-${i}`}
              data-testid="table-column"
              rowSpan={rowSpan}
              style={styleColumn}
              onClick={() => {
                handleRecordClick();
              }}
            >
              {dataToDisplay}
            </td>
          );
        })}

        {/* Has footer and viewable, render footer without viewable icon*/}
        {hasFooter && viewable && <td className="c-table-records__footer"></td>}

        {viewable && !hasFooter && (
          <td
            className="c-table-records-more"
            data-testid="table-column"
            onClick={() => {
              handleRecordClick();
            }}
            style={{ ...removeBottomBordersStyle }}
          >
            {viewable && !Isviewable ? (
              <div>
                <MoreIcon tooltipText={moreIconTooltip} />
                {moreIconTooltip && (
                  // <Tooltip
                  //   id="c-table-records-more-tooltip"
                  //   place="bottom"
                  //   effect="solid"
                  // />
                  <></>
                )}
              </div>
            ) : (
              ""
            )}
          </td>
        )}
      </tr>

      {records.map((record, index) => {
        if (Array.isArray(record)) {
          return (
            <Fragment key={index}>
              {record.map((item, i) => {
                if (i == 0) {
                  return;
                }
                let keys = Object.keys(item);
                let style = {
                  backgroundColor: columnColor[index],
                  ...removeBottomBordersStyle,
                };
                let render = [];
                let countPush = 0;

                for (const key of keys) {
                  if (Array.isArray(item[key])) {
                    render.push(
                      item[key].map((r, localIndex) => {
                        let getKeys = Object.keys(r);
                        let rearrange = [];
                        let localStyle = {
                          backgroundColor:
                            columnColor[index + (localIndex + 1)],
                          ...removeBottomBordersStyle,
                        };

                        for (const localKey of getKeys) {
                          if (Array.isArray(r[localKey])) {
                            r[localKey].map((item) => {
                              rearrange[indexOfGroupHeader.indexOf(item.name)] =
                                item;
                            });

                            return rearrange.map((item, t) => {
                              let keys = Object.keys(item);
                              let sortingArr = sortDataSourceKeys(keys);

                              return sortingArr.map((k, j) => {
                                if (k !== "name") {
                                  let text = localItem[k];

                                  // * check key in nested floating points and assign floating point
                                  if (nestedFloatingPoints[k]) {
                                    text = localItem[k].toLocaleString(
                                      "en-US",
                                      {
                                        minimumFractionDigits:
                                          nestedFloatingPoints[k],
                                      }
                                    );
                                  }

                                  let className =
                                    "c-table-records__nested-record";

                                  if (showBlock) {
                                    className =
                                      "c-table-records__nested-record-block";
                                  }

                                  return (
                                    <td
                                      key={`first-group-row-${index}-${j}`}
                                      className={className}
                                      style={{
                                        ...localStyle,
                                        textAlign: nestedHeaderAlign[t][j - 1],
                                        borderBottom: `${
                                          showBlock ? "1px solid #eaf0fa" : 0
                                        }`,
                                        boxShadow: `${
                                          maximumRow === 1
                                            ? "none"
                                            : "0px 1px 0px #eaf0fa"
                                        }`,
                                      }}
                                    >
                                      <label className={viewableLabel}>
                                        {monospaceNumbers
                                          ? addSpanToText(text)
                                          : text}
                                      </label>
                                    </td>
                                  );
                                }
                              });
                            });
                          } else {
                            if (countPush < 1) {
                              item[key].map((localItem) => {
                                rearrange[
                                  indexOfGroupHeader.indexOf(
                                    localItem[getKeys[0]]
                                  )
                                ] = localItem;
                              });

                              countPush++;

                              return rearrange.map((localItem, t) => {
                                let keys = Object.keys(localItem);
                                let sortingArr = sortDataSourceKeys(keys);

                                return sortingArr.map((k, j) => {
                                  if (k !== keys[0]) {
                                    let text = localItem[k];

                                    // * check key in nested floating points and assign floating point
                                    if (nestedFloatingPoints[k]) {
                                      text = localItem[k].toLocaleString(
                                        "en-US",
                                        {
                                          minimumFractionDigits:
                                            nestedFloatingPoints[k],
                                        }
                                      );
                                    }

                                    let className =
                                      "c-table-records__nested-record";

                                    if (showBlock) {
                                      className =
                                        "c-table-records__nested-record-block";
                                    }

                                    return (
                                      <td
                                        key={`first-group-row-${index}-${j}`}
                                        className={className}
                                        style={{
                                          ...localStyle,
                                          textAlign:
                                            nestedHeaderAlign[t][j - 1],
                                          borderBottom: `${
                                            showBlock ? "1px solid #eaf0fa" : 0
                                          }`,
                                          boxShadow: `${
                                            maximumRow === 1
                                              ? "none"
                                              : "0px 1px 0px #eaf0fa"
                                          }`,
                                        }}
                                      >
                                        {monospaceNumbers
                                          ? addSpanToText(text)
                                          : text}
                                      </td>
                                    );
                                  }
                                });
                              });
                            }
                          }
                        }
                      })
                    );
                  } else {
                    let borderRight = 0;

                    if (showBlock && keys.indexOf(key) !== keys.length - 1) {
                      borderRight = "1px solid #eaf0fa";
                    }

                    render.push(
                      <td
                        key={`group-row-${i}`}
                        style={{
                          ...style,
                          textAlign: headerAlign[index],
                          borderRight: borderRight,
                          borderBottom: `${
                            showBlock ? "1px solid #eaf0fa" : 0
                          }`,
                          boxShadow: `${
                            maximumRow === 1 ? "none" : "0px 1px 0px #eaf0fa"
                          }`,
                          borderBottomLeftRadius: "0px",
                        }}
                        align={headerAlign[index]}
                      >
                        <label className={viewableLabel}>
                          {monospaceNumbers
                            ? addSpanToText(item[key])
                            : item[key]}
                        </label>
                      </td>
                    );
                  }
                }

                return (
                  <tr
                    key={uuidv4()}
                    className={className}
                    style={{
                      backgroundColor: `${rowSpan !== 1 ? "transparent" : ""}`,
                      borderBottom: `${showBlock ? "1px solid #eaf0fa" : 0}`,
                      boxShadow: `${
                        maximumRow !== 1 ? "none" : "0px 1px 0px #eaf0fa"
                      }`,
                    }}
                  >
                    <td
                      style={{
                        backgroundColor: columnColor ? columnColor[0] : "",
                        ...selectedBoxStyle,
                      }}
                    />
                    {render}
                  </tr>
                );
              })}
            </Fragment>
          );
        }
      })}
    </>
  );
}

Row.propTypes = {
  enableSelection: PropTypes.bool,
  records: PropTypes.array,
  onSelectionChanged: PropTypes.func,
};

export default Row;
